import { render, staticRenderFns } from "./TgDateSearch.vue?vue&type=template&id=3942e6b3"
import script from "./TgDateSearch.vue?vue&type=script&lang=js"
export * from "./TgDateSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports